import { graphql } from 'react-apollo'

import { withAnalyticsClient } from '@acorns/web-utils'
import { datadogRum } from '@datadog/browser-rum'
import { Try } from 'monapt'
import {
  compose,
  lifecycle,
  withHandlers,
  withProps,
  withPropsOnChange,
} from 'recompose'

import { WebViewProps } from 'pages/spend/direct-deposit/WebViewComponents'

import query from './query.gql'

export default compose<WebViewProps, {}>(
  withAnalyticsClient,
  graphql(query),
  withProps(({ data }) => {
    if (!data.loading) {
      return {
        mobileUuid: window.mobileUuid,
        mobileSessionId: window.mobileSessionId,
      }
    } else {
      return {}
    }
  }),
  withPropsOnChange(
    ['data'],
    ({ analytics, data, mobileUuid, mobileSessionId }) => {
      if (
        !data.loading &&
        (mobileUuid !== undefined ||
          (data.user && data.user.uuid !== undefined))
      ) {
        // Note: Identify the user once for analytic events
        const userId = mobileUuid || data.user.uuid

        analytics.setContext({
          sessionId: mobileSessionId,
        })

        analytics.identify(userId, {
          userId,
        })
      }
    },
  ),
  withHandlers({
    handleWebViewExit:
      ({ trackClick }) =>
      () => {
        Try(() => trackClick())
        window.location.assign(
          'acorns://event?flow_complete=true&error=false&email=false',
        )
      },
    handleWebViewBack:
      ({ trackClick, history }) =>
      () => {
        Try(() => trackClick())
        history.push('/wv/spend/direct-deposit/search')
      },
  }),
  lifecycle({
    componentDidCatch(error) {
      datadogRum.addError(error)
      window.location.assign('acorns://event?flow_complete=false&error=true')
    },
  }),
)
